export default __webpack_public_path__ + "static/media/crown.d1c6873d.png";